import React from 'react'
import Head from '../components/Head.js'
import {BaseStyles} from '@primer/components'
import GlobalStyle from '../components/Global.js'
import Bar from '../components/Bar.js'
import Hero from '../components/Hero.js'
import Steps from '../components/Steps.js'
import Faq from '../components/Faq.js'

export default props =>
<BaseStyles>
  <Head />
  <GlobalStyle />
  <Bar />
  <Hero 
    href="/"
    title="Help shape the future of GitHub"
    desc="Lend us your voice so that we can make GitHub better for people like you."
    link="https://airtable.com/shrNwQ4X247Bm4drZ"
  />
  <Steps
    link="https://airtable.com/shrNwQ4X247Bm4drZ"
  />
  <Faq />
</BaseStyles>